import React, { Fragment, Component } from 'react'
import {
  BrowserRouter as Router,
  Route,
  withRouter,
  Redirect,
} from 'react-router-dom'
import {
  GuestReadMore,
  TrustReadMore,
  HostReadMore,
  LogOut,
  AdminLogOut,
} from './Pages' // import our pages
import FAQ from './FAQ'
import AboutUs from './AboutUs'
import HowItWorksV3 from './HowItWorksV3'
import Contact from './Contact'
import Blog from './Blog/Blog'
import Post from './Blog/Post'
import ResetMail from './Auth/ResetMail'
import ResetPassword from './Auth/ResetPassword'
import SignupNew from './SignupNew'
import SignupNewSplit1 from './SignupNewSplit1'
import ThanksForSigningUp from './ThanksForSigningUp'
import SignupMailingList from './SignupMailingList'
import SignupMailingListSubmitted from './SignupMailingListSubmitted'
import SignupMailingListActivate from './SignupMailingListActivate'
import LoginAuth0 from './LoginAuth0'
import LoginSignup from './LoginSignup'
import LoginRouter from './Dashboard/LoginRouter'
import LoggedOut from './LoggedOut'
import Dashboard from './Dashboard/Dashboard'
import MyFreebirdOnboardingSteps from './Dashboard/MyFreebirdOnboardingSteps'
import CompleteLaterApp from './Dashboard/CompleteLaterApp'
import Community from './Dashboard/Community'
import Community2 from './Dashboard/Community2'
import MyFreebird from './Dashboard/MyFreebird'
import MyFreebirdFreemium from './Dashboard/MyFreebirdFreemium'
import ChooseMembershipFee from './Dashboard/ChooseMembershipFee'
import EditIdentity from './Dashboard/EditIdentity'
import PhoneNumberVerify from './Dashboard/PhoneNumberVerify'
import Fee from './Dashboard/Fee'
import HostSignup from './Dashboard/HostSignup'
import Place from './Search/Place'
import User from './Search/User'
import Message from './Search/Message'
import Home from './Home'
import HomeFB1 from './HomeFB1'
import Members from './Search/Members'
import Listings from './Search/Listings'
import AboutUsNew from './AboutUsNew'
import CircleProfile from './Circle/CircleProfile'

import AdminLogin from './Admin/Login'
import AdminDashboard from './Admin/Dashboard'

import { PrivateRoute, withAuth } from './AuthContext'
import TermsConditions from './TermsConditions'
import TermsOfSupply from './TermsOfSupply'
import Testimonials from './Testimonials'
import Partners from './Partners'
import PrivacyPolicy from './PrivacyPolicy'
import CookiePolicy from './CookiePolicy'
import { NotificationContainer } from 'react-notifications'
import { StyleGuide } from './StyleGuide'
import OurStory from './OurStory'

import TagManager from 'react-gtm-module'
import ReactGA from 'react-ga4'
import Cookies from 'universal-cookie'
import PlaceBooking from './Search/PlaceBooking'
import PlaceRequestSent from './Search/PlaceRequestSent'
import PlaceBookingPaid from './Search/PlaceBookingPaid'

import BecomeHost from './BecomeHost'

import ChooseMembershipFeeGift from './Dashboard/ChooseMembershipFeeGift'
import FeePayAsYouChooseGift from './Dashboard/FeePayAsYouChooseGift'
import SignupGiftCompleted from './SignupGiftCompleted'
import SignupGiftActivate from './SignupGiftActivate'
import SignupGiftCustodian from './SignupGiftCustodian'
import SignupGiftRecipient from './SignupGiftRecipient'
import Christmas from './Christmas'
import ChristmasGift from './ChristmasGift'
import SelectGiftPayment from './SelectGiftPayment'
import WelcomeCongrats from './WelcomeCongrats'

import GiftYourGrownUp from './GiftYourGrownUp'
import GiftYourGrownUpVariantB from './GiftYourGrownUpVariantB'
import GiftYourGrownUpVariantC from './GiftYourGrownUpVariantC'
import GiftYourCustodianForm from './GiftYourCustodianForm'
import GiftYourCustodianFormB from './GiftYourCustodianFormB'
import GiftYourRecipientForm from './GiftYourRecipientForm'
import GiftYourPaymentChoice from './GiftYourPaymentChoice'
import GiftYourWelcomeCongrats from './GiftYourWelcomeCongrats'
import GiftYourPayByStripe from './GiftYourPayByStripe'
import FacebookHost from './FacebookHost'
import Homepage from './Homepage'
import HomepageV2 from './HomepageV2'
import HomepageV3 from './HomepageV3'
import ListRequestsRedirect from './Dashboard/ListRequestsRedirect'
import ProofAddress from './Dashboard/ProofAddress'
import Homestays from './Homestays'
import MemberMatchTest from './MemberMatchTest'
import Auth0Test from './Auth0Test'
import NewHeader from './NewHeader'
import NewHeaderMinimal from './NewHeaderMinimal'
import NewHeaderOnboarding from './NewHeaderOnboarding'
import SignupLandingPage from './SignupLandingPage'
import SignupPlainForm from './SignupPlainForm'
import OurPrices from './OurPrices'
import SafetyTips from './SafetyTips'
const cookies = new Cookies()

const tagManagerArgs = {
  gtmId: 'GTM-WCJ88GQ',
}

TagManager.initialize(tagManagerArgs)
ReactGA.initialize('G-8LHSLNP4P1')

const queryParams = new URLSearchParams(window.location.search)
// Source code (traffic source, affiliate)
const sC = queryParams.get('sc')
if (sC != '' && sC != null) {
  cookies.set('sC', sC, { path: '/' })
}
// Discount code
/*
if (cookies.get('dC') == '' || cookies.get('dC') == null) {
    const dC = queryParams.get("dc");
    if (dC != '' && dC != null) {
        cookies.set('dC', dC, { path: '/' });
    } else {
        cookies.set('dC', '', { path: '/' });
    };
}
*/

//Special offer - all users get the special fiver price
//cookies.set('dC', '100501', { path: '/' })

// Banner code
/*
if (cookies.get('bC') == '' || cookies.get('bC') == null) {
    const bC = queryParams.get("bc");
    if (bC != '' && bC != null) {
        cookies.set('bC', bC, { path: '/' });
    } else {
        cookies.set('bC', '', { path: '/' });
    };
}
*/
// Country code
if (cookies.get('cC') == '' || cookies.get('cC') == null) {
  const cC = queryParams.get('cc')
  if (cC != '' && cC != null) {
    cookies.set('cC', cC, { path: '/' })
  } else {
    cookies.set('cC', '', { path: '/' })
  }
}
// Currency value
if (cookies.get('cV') == '' || cookies.get('cV') == null) {
  const cV = queryParams.get('cv')
  if (cV != '' && cV != null) {
    cookies.set('cV', cV, { path: '/' })
  } else {
    cookies.set('cV', '', { path: '/' })
  }
}
// Currency sign
if (cookies.get('cS') == '' || cookies.get('cS') == null) {
  const cS = queryParams.get('cs')
  if (cS != '' && cS != null) {
    cookies.set('cS', cS, { path: '/' })
  } else {
    cookies.set('cS', '', { path: '/' })
  }
}
// Language code
const lC = queryParams.get('lc')
if (lC != '' && lC != null) {
  cookies.set('lC', lC, { path: '/' })
}
// Redirection after login
if (cookies.get('rdv') == '' || cookies.get('rdv') == null) {
  const rDv = queryParams.get('rdv')
  if (rDv != '' && rDv != null) {
    cookies.set('rdv', rDv, { path: '/' })
  } else {
    cookies.set('rdv', '', { path: '/' })
  }
}
// Facebook tracking - UTM source
if (cookies.get('utmS') == '' || cookies.get('utmS') == null) {
  const utmS = queryParams.get('utm_source')
  if (utmS != '' && utmS != null) {
    cookies.set('utmS', utmS, { path: '/' })
  } else {
    cookies.set('utmS', '', { path: '/' })
  }
}
// Facebook tracking - UTM medium
if (cookies.get('utmM') == '' || cookies.get('utmM') == null) {
  const utmM = queryParams.get('utm_medium')
  if (utmM != '' && utmM != null) {
    cookies.set('utmM', utmM, { path: '/' })
  } else {
    cookies.set('utmM', '', { path: '/' })
  }
}
// Facebook tracking - UTM campaign
if (cookies.get('utmCa') == '' || cookies.get('utmCa') == null) {
  const utmCa = queryParams.get('utm_campaign')
  if (utmCa != '' && utmCa != null) {
    cookies.set('utmCa', utmCa, { path: '/' })
  } else {
    cookies.set('utmCa', '', { path: '/' })
  }
}
// Facebook tracking - UTM content
if (cookies.get('utmCo') == '' || cookies.get('utmCo') == null) {
  const utmCo = queryParams.get('utm_content')
  if (utmCo != '' && utmCo != null) {
    cookies.set('utmCo', utmCo, { path: '/' })
  } else {
    cookies.set('utmCo', '', { path: '/' })
  }
}

// Workaround for the wrapped header (homepage) vs top header (other pages)
const addHeader = (Component) => {
  return (props) => (
    <Fragment>
      {/* <Header id="header-menu-only" className="header" /> */}
      <NewHeader />
      <div>
        <Component {...props} />
      </div>
    </Fragment>
  )
}

const addHeaderMinimal = (Component) => {
  return (props) => (
    <Fragment>
      {/* <Header id="header-menu-only" className="header" /> */}
      <NewHeaderMinimal />
      <div>
        <Component {...props} />
      </div>
    </Fragment>
  )
}

const addHeaderOnboarding = (Component) => {
  return (props) => (
    <Fragment>
      <NewHeaderOnboarding />
      <div>
        <Component {...props} />
      </div>
    </Fragment>
  )
}

// React Router setup. Defines front-end routing between Components
class Main extends Component {
  constructor(props) {
    super(props)
    let editorLinks = [
      {
        path: '/admin/dashboard/posts',
        text: 'Posts',
        isActive: true,
      },
      {
        path: '/admin/dashboard/pages',
        text: 'Pages',
        isActive: false,
      },
      {
        path: '/admin/dashboard/admins',
        text: 'Admins',
        isActive: false,
      },
      {
        path: '/admin/logout',
        text: 'Logout',
        isActive: false,
      },
    ]
    this.state = {
      editorLinks,
      data: null,
    }
    this.handleEditorDashboardNav = this.handleEditorDashboardNav.bind(this)
    this.setLocaleData = this.setLocaleData.bind(this)
  }

  handleEditorDashboardNav(i) {
    const links = this.state.editorLinks.slice()
    for (const j in links) {
      links[j].isActive = i == j
    }
    this.setState({ editorLinks: links })
  }

  setLocaleData() {
    const apiUrl = '/api/locale'
    axios
      .get(apiUrl)
      .then((response) => {
        cookies.set('cC', response.data.country, { path: '/' })
        cookies.set('cV', response.data.currency, { path: '/' })
        cookies.set('cS', response.data.sign, { path: '/' })
        //cookies.set('lC', response.data.language, { path: '/' });

        this.setState({
          data: 'ok',
        })
      })
      .catch((e) => {
        cookies.set('cC', 'IE', { path: '/' })
        cookies.set('cV', 'EUR', { path: '/' })
        cookies.set('cS', '&euro;', { path: '/' })
        //cookies.set('lC', 'en', { path: '/' });

        this.setState({
          data: 'fail',
        })
      })
  }

  componentDidMount() {
    if (
      cookies.get('cV') == '' ||
      cookies.get('cV') == undefined ||
      (cookies.get('cV') == '') == null
    ) {
      this.setLocaleData()
    } else {
      this.setState({
        data: 'ok',
      })
    }
  }

  render() {
    const EditorDashboard = addHeader(AdminDashboard)
    if (!this.state.data) {
      return null
    }
    return (
      <div>
        <Route exact path="/auth0-test" component={addHeader(Auth0Test)} />
        <Route exact path="/" component={addHeader(HomepageV3)} />
        <Route exact path="/homepage-v1" component={addHeader(Homepage)} />
        <Route exact path="/homepage-v2" component={addHeader(HomepageV2)} />
        <Route exact path="/1020230001" component={HomeFB1} />
        <Route exact path="/offer" component={HomeFB1} />
        {/*<Route exact path="/specialoffer" component={addHeader(SpecialOfferFiver)} />*/}
        <Route path="/login" component={addHeader(LoginAuth0)} />
        <Route path="/loginsignup" component={addHeader(LoginSignup)} />
        <Route path="/loggedout" component={addHeader(LoggedOut)} />
        <Route path="/reset-mail" component={addHeader(ResetMail)} />
        <Route
          path="/password/reset/:token"
          component={addHeader(ResetPassword)}
        />
        <Route path="/search" component={addHeader(Listings)} />
        <Route path="/members" component={addHeader(Members)} />
        <PrivateRoute path="/logout" component={addHeader(LogOut)} />
        <Route path="/signup" component={addHeader(SignupLandingPage)} />
        <Route path="/signup-form" component={addHeader(SignupPlainForm)} />
        <Route path="/signup-s1" component={addHeader(SignupNewSplit1)} />
        <Route
          path="/signup-complete"
          component={addHeader(ThanksForSigningUp)}
        />
        <Route path="/signup-ml" component={addHeader(SignupMailingList)} />
        <Route
          path="/signup-ml-submitted"
          component={addHeader(SignupMailingListSubmitted)}
        />
        <Route
          path="/signup-ml-activate"
          component={addHeader(SignupMailingListActivate)}
        />
        <Route
          path="/signup-ml-activate-code"
          component={addHeader(SignupMailingListActivate)}
        />
        <Route
          exact
          path="/gift-your-grown-up"
          component={addHeader(GiftYourGrownUp)}
        />
        <Route
          exact
          path="/gift-your-grown-up-b"
          component={addHeader(GiftYourGrownUpVariantB)}
        />
        <Route
          exact
          path="/gift-your-grown-up-c"
          component={addHeader(GiftYourGrownUpVariantC)}
        />
        <Route
          exact
          path="/gift-your-grown-up/step-1"
          component={addHeader(GiftYourCustodianForm)}
        />
        <Route
          exact
          path="/gift-your-grown-up/step-1-b"
          component={addHeader(GiftYourCustodianFormB)}
        />
        <Route
          exact
          path="/gift-your-grown-up/step-2"
          component={addHeader(GiftYourRecipientForm)}
        />
        <PrivateRoute
          exact
          path="/gift-your-grown-up/payment-choice"
          component={addHeader(GiftYourPaymentChoice)}
        />
        <PrivateRoute
          exact
          path="/gift-your-grown-up/pay-by-cc"
          component={addHeader(GiftYourPayByStripe)}
        />
        <PrivateRoute
          exact
          path="/gift-your-grown-up/completed"
          component={addHeader(GiftYourWelcomeCongrats)}
        />
        <Route
          exact
          path="/gift-your-grown-up/gift/activate"
          component={addHeader(GiftYourWelcomeCongrats)}
        />
        <Route
          exact
          path="/signup-gift"
          render={() => <Redirect to={{ pathname: '/signup-gift/step-1' }} />}
        />
        <Route
          exact
          path="/signup-gift/step-1"
          component={addHeader(SignupGiftCustodian)}
        />
        <Route
          exact
          path="/signup-gift/step-2"
          component={addHeader(SignupGiftRecipient)}
        />
        <Route
          exact
          path="/gift/activate"
          component={addHeader(SignupGiftActivate)}
        />
        <PrivateRoute
          exact
          path="/signup-gift/choose-payment"
          component={addHeader(ChooseMembershipFeeGift)}
        />
        <PrivateRoute
          exact
          path="/signup-gift/payc-fee"
          component={addHeader(FeePayAsYouChooseGift)}
        />
        <PrivateRoute
          exact
          path="/signup-gift/completed"
          component={addHeader(SignupGiftCompleted)}
        />
        {/*<Route path="/signup" component={addHeader(SignupAndPay)} />*/}
        <Route path="/our-story" component={addHeader(OurStory)} />
        <Route path="/prices" component={addHeader(OurPrices)} />
        <Route path="/about-us-old" component={addHeader(AboutUs)} />
        <Route path="/about-us" component={addHeader(AboutUsNew)} />
        <Route path="/guest-readmore" component={addHeader(GuestReadMore)} />
        <Route path="/trust-readmore" component={addHeader(TrustReadMore)} />
        <Route path="/host-readmore" component={addHeader(HostReadMore)} />
        <Route path="/how-it-works" component={addHeader(HowItWorksV3)} />
        <Route path="/reviews" component={addHeader(Testimonials)} />
        <Route path="/partners" component={addHeader(Partners)} />
        <Route path="/contact" component={addHeader(Contact)} />
        <Route path="/homestay-safety-tips" component={addHeader(SafetyTips)} />
        <Route
          path="/terms-conditions"
          component={addHeader(TermsConditions)}
        />
        <Route path="/terms-of-supply" component={addHeader(TermsOfSupply)} />
        <Route path="/privacy-policy" component={addHeader(PrivacyPolicy)} />
        <Route path="/cookie-policy" component={addHeader(CookiePolicy)} />
        <Route path="/travel-guide" component={addHeader(Blog)} />
        <Route path="/blog" component={addHeader(Blog)} />
        <Route path="/styleguide" component={addHeader(StyleGuide)} />
        <Route path="/post/:id" component={addHeader(Post)} />
        <Route path="/faq" component={addHeader(FAQ)} />
        <Route exact path="/place/:id" component={addHeader(Place)} />
        <Route path="/user/:id" component={addHeader(User)} />
        <Route path="/admin/login" component={addHeader(AdminLogin)} />
        <Route
          path="/facebook-become-host"
          component={addHeader(FacebookHost)}
        />
        <PrivateRoute
          exact
          path="/place/:id/request-sent"
          component={addHeader(PlaceRequestSent)}
        />
        <PrivateRoute
          exact
          path="/place/:id/booking"
          component={addHeader(PlaceBooking)}
        />
        <PrivateRoute
          exact
          path="/place/:id/booking/paid"
          component={addHeader(PlaceBookingPaid)}
        />
        <PrivateRoute
          exact
          path="/onboarding"
          component={MyFreebirdOnboardingSteps}
        />
        <PrivateRoute
          exact
          path="/dashboard"
          component={addHeaderMinimal(MyFreebird)}
        />
        <PrivateRoute
          exact
          path="/myfreebird"
          component={addHeaderMinimal(MyFreebirdFreemium)}
        />
        <PrivateRoute
          exact
          path="/dashboard/loginrouter"
          component={addHeaderMinimal(withAuth(LoginRouter))}
        />
        <PrivateRoute
          exact
          path="/dashboard/complete-later"
          component={addHeaderMinimal(CompleteLaterApp)}
        />
        <PrivateRoute
          exact
          path="/dashboard/community"
          component={addHeaderMinimal(Community)}
        />
        <PrivateRoute
          exact
          path="/dashboard/community2"
          component={addHeaderMinimal(Community2)}
        />
        <PrivateRoute
          exact
          path="/dashboard/messages"
          component={addHeaderMinimal(Dashboard)}
        />
        <PrivateRoute
          exact
          path="/dashboard/messages/:id"
          component={addHeaderMinimal(Dashboard)}
        />
        <PrivateRoute
          exact
          path="/dashboard/bookings"
          component={addHeaderMinimal(Dashboard)}
        />
        <Route
          exact
          path="/dashboard/requests"
          component={ListRequestsRedirect}
        />
        <PrivateRoute
          exact
          path="/dashboard/requests/live"
          component={addHeaderMinimal(Dashboard)}
        />
        <PrivateRoute
          exact
          path="/dashboard/requests/pending"
          component={addHeaderMinimal(Dashboard)}
        />
        <PrivateRoute
          exact
          path="/dashboard/requests/past"
          component={addHeaderMinimal(Dashboard)}
        />
        <PrivateRoute
          exact
          path="/dashboard/calendar"
          component={addHeaderMinimal(Dashboard)}
        />
        <PrivateRoute
          exact
          path="/dashboard/choose-membership-fee"
          component={addHeaderMinimal(ChooseMembershipFee)}
        />
        <PrivateRoute
          exact
          path="/dashboard/edit-place"
          component={addHeaderMinimal(Dashboard)}
        />
        <PrivateRoute
          exact
          path="/dashboard/pay-fee"
          component={addHeaderMinimal(Fee)}
        />
        <PrivateRoute
          exact
          path="/dashboard/host-signup"
          component={addHeaderMinimal(HostSignup)}
        />
        <PrivateRoute
          exact
          path="/dashboard/edit-identity"
          component={addHeaderMinimal(EditIdentity)}
        />
        <PrivateRoute
          path="/NMBSXw873qt4e2fvJVJV"
          component={addHeader(MemberMatchTest)}
        />
        <Route path="/become-host" component={addHeader(BecomeHost)} />
        <Route path="/homepage" component={addHeader(HomepageV2)} />
        <Route path="/homepage-v2" component={addHeader(Home)} />
        <Route path="/homepage-header" component={addHeader(HomepageV2)} />
        <Route path="/homestays" component={addHeader(Homestays)} />
        <Route path="/christmas" component={addHeader(Christmas)} />
        <Route path="/christmas-gift" component={addHeader(ChristmasGift)} />
        <Route path="/circle-profile" component={addHeader(CircleProfile)} />

        <Route
          path="/congratulations-gift-purchase"
          component={addHeader(WelcomeCongrats)}
        />
        <Route path="/welcome-gift" component={addHeader(WelcomeCongrats)} />
        <Route
          path="/select-gift-payment"
          component={addHeader(SelectGiftPayment)}
        />
        <PrivateRoute
          exact
          path="/dashboard/edit-phonenumber/verify"
          component={addHeaderMinimal(PhoneNumberVerify)}
        />
        <PrivateRoute
          exact
          path="/dashboard/edit-place/proof"
          component={addHeaderMinimal(ProofAddress)}
        />
        <PrivateRoute
          exact
          path="/send-message/:uuid"
          component={addHeaderMinimal(Message)}
        />
        <Route
          path="/admin/dashboard"
          render={(props) => (
            <EditorDashboard
              {...props}
              links={this.state.editorLinks}
              handleClick={this.handleEditorDashboardNav}
            />
          )}
        />
        <Route path="/admin/logout" component={addHeader(AdminLogOut)} />
        <Route
          exact
          path="/admin"
          render={(props) => (
            <Redirect
              to={{
                pathname: '/admin/dashboard',
                state: { from: props.location },
              }}
            />
          )}
        />
        <NotificationContainer />
      </div>
    )
  }
}

export default withRouter(withAuth(Main))
